export const projectTypeOptionsCarity = [
    "Food",
    "Car Donation",
    "Refuse Assistant",
    "Rental Assistant",
  
  ];

  export const projectTypeOptionsDevelopment = [
    "Lab",
    "Equipments",
    "Constructions",
    "Club Sponsorship",
  
  ];
  